import React, { useEffect, useMemo } from 'react'
import Footer from '../components/Sections/Footer'
import CardProduct from '../components/CardProduct/cardProduct'
import { useDispatch, useSelector } from 'react-redux'
import { GetproductAccessories, numberWithCommas } from '../redux/actions/product'
import Navigantions from '../components/Nav/navigations';
import { Link } from 'react-router-dom'
import { checkPhoto } from '../components/CardProduct/cardProduct.function'


export default function ProductWomen() {
  const dispatch = useDispatch();

  const { dataAccessories, dataSearch } = useSelector((s) => s.Product);

  useEffect(() => {
    dispatch(GetproductAccessories())
  }, [dispatch, dataSearch?.payload])

  const filterSearch = useMemo(() => {
    return dataAccessories?.filter((val) => val.product_label === dataSearch?.payload)
  },[dataSearch?.payload, dataAccessories])

  return (
      <div className="page-wrapper">
        <Navigantions />
        <div className="container content-wrapper">
          {/* Konten utama */}
          <div className='mt100'>
            <h3 className="font40 extraBold textCenter fontRobotto">{`Accessories (${dataSearch?.payload})`}</h3>
            {filterSearch?.length > 0 ? (
              <div className="subcontainer">
                <div className="grid">
                  {filterSearch?.map((item, index) => (
                    <Link key={index} to={`/detail_product/product_accessories/${item?.product_id}`}>
                      <CardProduct
                        image={checkPhoto(item.product_photo, 'productAccessories')}
                        title={item.product_name}
                        price={numberWithCommas(item.product_price)}
                      />
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <p className='fontEmptyData font20 fontCabin'>Sorry, there are no products in this collection</p>
            )}
          </div>
        </div>
        <Footer />
      </div>
  )
}
